<!-- <article class="sim-banner pt-0">
  <div class="sl-bg">
    <div class="container-fluid">
      <div class="row align-items-center">
         <div class="col-sm-12 col-md-5">
          <div class="simmer-animation sim-heading"></div>
          <div class="simmer-animation sim-date"></div>
          <div class="simmer-animation sim-description"></div>
          <div class="simmer-animation sim-btn btn"></div>
        </div> 
      </div>
    </div>
  </div>
</article>-->

<section class="slider-simmer">
  <div class="simmer-animation"></div>
  <div class="simmer-animation"></div>
  <div class="simmer-animation center"></div>
  <div class="simmer-animation"></div>
  <div class="simmer-animation"></div>
</section>
